const accordionButtons = document.querySelectorAll(".js-accordion-button");

if (typeof accordionButtons != "undefined" && accordionButtons != null) {
    accordionButtons.forEach((button) => {
        let panel = button.parentNode;
        let answer = button.nextElementSibling;
        let isActive = false;
        let isActiveClass = 'is-active';

        button.addEventListener('click',function(){
            isActive = !isActive
            if (isActive) {
                panel.classList.add(isActiveClass);
                answer.style.maxHeight = answer.scrollHeight + "px";
            } else {
                panel.classList.remove(isActiveClass);
                answer.style.maxHeight = null;
            }
            
        });
    });
}
